import React from 'react';
import FooterHero from '../../component/common/CTA'
import HeroSection from '../../component/common/hero'
import HowWeHelp from '../../component/common/howWeHelp'
import CaseStudySlider from '../../component/common/caseStudy'
import { Helmet } from 'react-helmet-async';

const caseStudiesData = [
  {
    image: "img/logos/your-space.png",
    heading: "Your Space",
    content:
      "TurningIdeas Ventures collaborated with Your-Space, a leading student housing startup in India, to accelerate their growth and expand their footprint in the competitive co-living market. Our team provided strategic guidance on scaling operations, optimizing tech infrastructure, and refining the GTM strategy to enhance customer acquisition. By leveraging data-driven insights, enterprise partnerships, and investor connections, we helped Your-Space achieve higher occupancy rates, operational efficiency, and rapid geographic expansion. Our tailored growth strategies enabled them to raise funding, strengthen their brand presence, and solidify their position as a market leader in India’s student housing sector.",
    link: "https://www.your-space.in/",
  },
  {
    image: "img/logos/whizdom.png",
    heading: "Whizdom Club",
    content:
      "TurningIdeas Ventures partnered with Whizdom Club India, a venture by Magnolia Quality Development Corporation (MQDC) Thailand, to establish and scale their premium innovation and coworking space in India. We provided end-to-end market entry strategy, brand positioning, and community-building initiatives, ensuring a seamless launch in the highly competitive Indian market. From curating startup engagement programs to driving occupancy growth and partnerships, we played a key role in positioning Whizdom Club as a hub for entrepreneurs, innovators, and creatives. Our expertise in business acceleration and corporate innovation helped Whizdom India achieve rapid traction and a strong foothold in the ecosystem. 🚀",
    link: "https://www.whizdomindia.com/",
  },
];

const heroData = {
  title: {
    bold: "Indian",
    light: "Startups",
  },
  subtitle: "Accelerate Growth Across Asia",
  description: {
    heading: "Scale Your Startup Beyond India",
    intro: "Indian startups have immense potential to grow, but",
    outro: "often slow them down. We help you accelerate growth with a structured approach."
  },
  highlightedText: "funding, sales, and execution challenges",
  heroImage: "img/indian-hero.png",
  bgImg: "img/indian-hero-bg.png",
  btnText: "Accelerate Growth",
  btnLink: "https://forms.gle/F1AhEsmWPnMmpXGM7"
};

const serviceCards = [
  {
    title: "Product Market Fit Validation",
    text: "Ensuring your product is ready to scale.",
    subtext: "",
    iconLink: "img/indian-help1.png" // Target icon
  },
  {
    title: "Investor & Funding Support",
    text: "Connecting you with VCs & angel investors.",
    subtext: "",
    iconLink: "img/indian-help2.png" // Money icon
  },
  {
    title: "Sales & GTM Acceleration",
    text: "Helping you close enterprise deals faster.",
    subtext: "",
    iconLink: "img/indian-help3.png" // Growth chart icon
  },
  {
    title: "Operational Scale-Up",
    text: "Optimizing your business for rapid expansion.",
    subtext: "",
    iconLink: "img/indian-help4.png" // Rocket icon
  }
];

const statsDataHeading = {
  light: "Why work with",
  bold: "us?"
}

const statsData = [
  {
    title: "$142 Million+",
    text: "raised by our clients"
  },
  {
    title: "11",
    text: "Enterprise Secured"
  },
  {
    title: "164",
    text: "Startups Mentored"
  }
];

const worldMapImg = "img/why-indian.png";


const headerData = {
  title: "How We Help",
  highlightedText: "Indian Startups",
  normalText: "Scale",
  description: "From idea to exit, together, when we partner with founders, we're all in combining expertise, empathy, embedded resources, and capital to build breakout companies",
  imgLink: "img/help-indian.png"
};

const IndiaPage = () => {
  return (
    <div>

      <Helmet>
        <title>Accelerate Your Startup Growth | Fundraising & Scaling Support in India</title>
        <meta name="description" content="TurningIdeas helps Indian startups accelerate growth, secure funding, and scale faster with expert mentorship, sales execution, and corporate partnerships." />
        <meta name="keywords" content="Indian startups, startup funding, raise capital, accelerate growth, startup mentorship, scale your startup, venture funding, go-to-market strategy, sales execution, startup investors, corporate partnerships, product-market fit, business expansion, angel investors, VC funding, startup accelerator, India startup ecosystem, startup mentorship program, growth hacking, early-stage startup funding" />
      </Helmet>


      <HeroSection
        title={heroData.title}
        subtitle={heroData.subtitle}
        description={heroData.description}
        highlightedText={heroData.highlightedText}
        callToAction={heroData.callToAction}
        heroImage={heroData.heroImage}
        bgImg={heroData.bgImg}
        btnText={heroData.btnText}
        btnLink={heroData.btnLink}
      />

      <section className="py-6 md:py-12">
        <div className="container mx-auto px-6 md:px-12">
          <HowWeHelp
            headerData={headerData}
            serviceCards={serviceCards}
            statsDataHeading={statsDataHeading}
            statsData={statsData}
            worldMapImg={worldMapImg}
          />
        </div>
      </section>

      <section className="py-6 md:py-12 bg-black">
        <div className="container mx-auto px-6 md:px-12">
          <CaseStudySlider caseStudies={caseStudiesData} />
        </div>
      </section>


      <FooterHero
        heading="Let’s Build Together"
        subheading="Join the TurningIdeas Ecosystem"
        paragraph="Whether you're a startup, investor, or enterprise, we help you scale, innovate, and succeed."
        buttonText="Contact Us Today!"
      />
    </div>
  );
};

export default IndiaPage;
